import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { Subscription, take } from 'rxjs';
import { ShopItemAdminStoreService } from 'src/app/shared/services/store/shop-item-admin-store.service';


@Component({
  selector: 'app-location-code',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, InputTextModule,
    TranslateModule
  ],
  templateUrl: './location-code.component.html',
  styleUrl: './location-code.component.scss'
})
export class LocationCodeComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input({ required: true }) codeFC!: FormControl<string | null>;

  @ViewChild('codeInput') codeInput: ElementRef | undefined;

  subs: Subscription[] = [];

  constructor() {}

  ngOnInit(): void {
    this.subs.push(
      this.codeFC.valueChanges.subscribe((value) => {
        if(this.codeInput) this.resizeInput(this.codeInput.nativeElement as HTMLInputElement);
      })
    );

  }

  ngAfterViewInit(): void {
    const input = this.codeInput?.nativeElement;
    if (input) {
      this.resizeInput(input as HTMLInputElement);
    }
  }

  private resizeInput(target: HTMLInputElement) {
    const width = Math.floor(getTextWidth(target));
    if (width === 0) {
      target.style.width = getTextWidth(target, target.placeholder) + 'px';
    } else {
      const widthInPx = (width) + "px";
      target.style.width = widthInPx;
    }
  }

  ngOnDestroy(): void {

  }
}


function getTextWidth(el: HTMLInputElement, placeholder?: string): number {
  // uses a cached canvas if available
  const canvas: HTMLCanvasElement = (getTextWidth as any).canvas || ((getTextWidth as any).canvas = document.createElement("canvas"));
  const context = canvas.getContext("2d");

  if (!context) {
    throw new Error("Could not get canvas context");
  }

  // get the full font style property
  const font = window.getComputedStyle(el, null).getPropertyValue('font');
  const text = el.value || (placeholder || '');
  // set the font attr for the canvas text
  context.font = font;
  const textMeasurement = context.measureText(text);
  return textMeasurement.width;
}

// Add a canvas property to the function to cache the canvas element
(getTextWidth as any).canvas = null as HTMLCanvasElement | null;

